/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/require-default-props */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-underscore-dangle */
import {
  Avatar, Divider, IconButton,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import Pagination from '@material-ui/lab/Pagination';
import icons from '../../constants/icons';
import color from '../../constants/color';
import {
  Arrows,
  ContainerPagination,
  HeaderTable,
  Img,
  ListContainer,
  Name,
  Options,
  Regional,
  Sigla,
  SizedBox,
  Status,
  User,
} from './styles';
import './styles.css';
import CustomizedSwitche from '../iosCheckCommon';
import MyLoader from '../placeholderCommon';
import DialogCommon from '../dialogCommon';
import SelectComponent from './component/select';
import CardContainerCommon from '../cardCommon';

interface Props {
  title: string;
  isSigla?: boolean;
  isSpecialist?: boolean;
  isRegional?: boolean;
  data: Array<any>;
  isEnterprise: boolean;
  inactiveEnterprise: Function;
  activeEnterprise: Function;
  activeOrIncactiveLocal: Function;
  isLoading: boolean;
  isUser?: boolean;
  selectData?: Array<any>;
  enterPriseData?: Array<any>;
  setFirstSelect: any;
  setSecondSelect: any;
  titleFirstSelect?: string;
  titleSecondSelect?: string;
  hasFilter?: boolean;
  onSave: Function;
  onEdit?: Function;
  onClean?: Function;
  isPlaceIcon?: boolean;
  openPlace?: Function;
  isMultiple: boolean;
  autoComplete?: boolean;
}

const TableCommon: React.FC<Props> = ({
  title,
  isSigla,
  isSpecialist,
  isRegional,
  data,
  isEnterprise,
  inactiveEnterprise,
  activeEnterprise,
  isLoading,
  isUser,
  activeOrIncactiveLocal,
  selectData,
  enterPriseData,
  hasFilter,
  onSave,
  onEdit,
  onClean,
  isPlaceIcon,
  openPlace,
  titleFirstSelect,
  titleSecondSelect,
  isMultiple,
  autoComplete,
}) => {
  const [perPage, setPerPage] = useState<number>(10);
  const [list, setList] = useState<Array<any>>(data);
  const [open, setOpen] = useState<boolean>(false);
  const [firstSelectComponent, setFirstSelectComponent] = useState({ selecteds: [] });
  const [secondSelectComponent, setSecondSelectComponent] = useState({ selecteds: [] });
  const [page, setPage] = useState<number>(1);
  const [pageSelected, setPageSelected] = useState(1);

  const paginate = () => {
    const pages: number = data.length / perPage;
    setPage(Math.ceil(pages));
    setPageSelected(1);
  };

  const handleChange = (_e: any, _page: number) => {
    const newPage = _page * perPage;
    setList(
      data.filter((_item, index) => index >= newPage - perPage && index < newPage),
    );
    setPageSelected(_page);
  };

  const firtPage = () => {
    const newPage = pageSelected * perPage;
    setList(data.filter((_item, index) => index >= newPage - perPage && index < newPage));
    const pages: number = data.length / perPage;
    setPage(Math.ceil(pages));
  };

  useEffect(() => {
    paginate();
  }, [data]);

  useEffect(() => {
    firtPage();
  }, [data]);

  useEffect(() => {
    firtPage();
  }, [perPage]);

  const form = () => (
    <div style={{
      display: 'flex', flex: 1, flexDirection: 'column', height: 300,
    }}
    >
      <SizedBox style={{ marginTop: 13 }} />
      <SelectComponent
        autoComplete={autoComplete}
        value={autoComplete
          ? firstSelectComponent.selecteds[0] : firstSelectComponent.selecteds}
        label={titleFirstSelect}
        onChange={(event: any) => {
          if (autoComplete) {
            // @ts-ignore
            setFirstSelectComponent({ selecteds: [event] });
            setSecondSelectComponent({ selecteds: [] });
          } else {
            event.persist();
            setFirstSelectComponent((formState) => ({
              ...formState,
              [event.target.name]:
        event.target.type === 'checkbox'
          ? event.target.checked
          : event.target.value,
            }));
            setSecondSelectComponent({ selecteds: [] });
          }
        }}
        isMultiple={isMultiple}
        data={enterPriseData || []}
      />
      <SizedBox />
      <SelectComponent
        autoComplete={false}
        value={secondSelectComponent.selecteds}
        label={titleSecondSelect}
        onChange={(event: any) => {
          event.persist();
          setSecondSelectComponent((formState) => ({
            ...formState,
            [event.target.name]:
        event.target.type === 'checkbox'
          ? event.target.checked
          : event.target.value,
          }));
          setFirstSelectComponent({ selecteds: [] });
        }}
        isMultiple={isMultiple}
        data={selectData || []}
      />
      <SizedBox />
    </div>
  );

  const Body = () => (
    <>
      {isLoading ? (
        <div style={{ marginLeft: 30 }}>
          <MyLoader />
        </div>
      ) : (
        <>
          <HeaderTable>
            <Name>
              <div>NOME</div>
            </Name>
            {isSigla && (
              <Sigla>
                <div>SIGLA</div>
              </Sigla>
            )}
            <User>
              {isSpecialist ? (
                <div>
                  ESPECIALISTAS
                </div>
              ) : (
                <div>TIPO DE USUÁRIO</div>
              )}
            </User>
            {isRegional && (
              <Regional>
                <div>REGIONAL</div>
              </Regional>
            )}
            <Status>
              <div>STATUS</div>
            </Status>
            <Options>
              <div style={{ textTransform: 'uppercase' }}>Opções</div>
            </Options>
          </HeaderTable>
          <br />
          {list.map((item) => (
            <>
              <ListContainer key={item.idEmpreendimento || item.id || item}>
                <Name>
                  <Avatar style={{ marginRight: 10 }} alt="Empreendimento" src={item.urlImagem || item.nomeFotoUsuario} />
                  {isUser ? (
                    <div style={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column' }}>
                      <div style={{ textTransform: 'capitalize' }}>{item.nome}</div>
                      <div
                        style={{
                          wordBreak: 'break-word',
                          color: '#6E6893',
                          textTransform: 'lowercase',
                          marginTop: 5,
                        }}
                      >
                        {item.email}

                      </div>
                    </div>
                  ) : (
                    <div style={{
                      wordBreak: 'break-word',

                    }}
                    >
                      {item.nome}
                    </div>
                  )}
                </Name>
                {isSigla && (
                  <Sigla>
                    <div>{item.siglaNome}</div>
                  </Sigla>
                )}
                <User>
                  {isSpecialist ? (
                    <>
                      <div style={{ marginTop: 4 }}>
                        Nome
                      </div>
                      <div style={{
                        display: 'flex', flexDirection: 'column', marginTop: 4, marginBottom: 6,
                      }}
                      >
                        {item?.usuarios.map((it: any, index: number) => (
                          <div key={it + index.toString()} style={{ color: color.darkgrey }}>
                            {it.nome}
                            {' '}
                          </div>
                        ))}
                      </div>
                    </>
                  ) : (
                    <div>
                      <div>
                        <div style={{ display: 'flex', flexDirection: 'column', marginBottom: 4 }}>
                          <div style={{ marginTop: 2 }}>{item.nomePerfilAcesso}</div>
                        </div>
                      </div>
                      <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                        <div>Acesso:</div>
                        <div style={{
                          color: '#6E6893',
                          fontSize: 12,
                          marginTop: 2,
                        }}
                        >
                          {`${item.acessoAdmin ? 'Web' : ''}
                          ${(item.acessoAdmin && item.acessoMobile) ? ',' : ''}
                          ${item.acessoMobile ? 'Mobile' : ''}`}
                        </div>
                      </div>
                    </div>
                  )}
                </User>
                {isRegional && (
                  <Regional style={{ textTransform: 'capitalize' }}>
                    <div>{item.nomeRegional}</div>
                  </Regional>
                )}
                <Status>
                  <CustomizedSwitche
                    check={item.empreendimentoAtivo || item.ativo}
                    onClick={() => {
                      if (isEnterprise) {
                        if (item.empreendimentoAtivo) {
                          inactiveEnterprise(item.idEmpreendimento);
                        } else {
                          activeEnterprise(item.idEmpreendimento);
                        }
                      }
                      if (isUser) {
                        activeOrIncactiveLocal(item.id, item.ativo);
                      }
                    }}
                  />
                  <div>{item.empreendimentoAtivo || item.ativo ? 'Ativo' : 'Inativo'}</div>
                </Status>
                <Options>
                  {isPlaceIcon && (
                    <IconButton onClick={() => openPlace && openPlace(item)}>
                      <Img src={icons.placeIco} />
                    </IconButton>
                  )}
                  <IconButton onClick={() => onEdit && onEdit(item)}>
                    <Img src={icons.editIcon} />
                  </IconButton>
                </Options>
              </ListContainer>
              <Divider style={{ marginLeft: 30, marginRight: 30 }} />
            </>
          ))}
          <ContainerPagination>
            <Arrows>
              <Pagination
                color="standard"
                count={page}
                page={pageSelected}
                onChange={handleChange}
                showFirstButton
                size="small"
                variant="outlined"
                shape="round"
                showLastButton
              />
            </Arrows>
            <Arrows>
              <small>Itens por página</small>
              <select onChange={(event) => setPerPage(Number(event.target.value))} name="pages" id="pages">
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={50}>50</option>
              </select>
            </Arrows>
          </ContainerPagination>
        </>
      )}
      <DialogCommon
        isFilter
        width={300}
        onClean={() => {

        }}
        title="Filtros"
        open={open}
        loading={isLoading}
        setOpenModal={setOpen}
        onClose={() => {
          setOpen(false);
          if (onClean) {
            setFirstSelectComponent({ selecteds: [] });
            setSecondSelectComponent({ selecteds: [] });
            onClean();
          }
        }}
        saveText="FILTRAR"
        onSave={() => {
          onSave(firstSelectComponent.selecteds,
            secondSelectComponent.selecteds);
          setOpen(false);
          setFirstSelectComponent({ selecteds: [] });
          setSecondSelectComponent({ selecteds: [] });
        }}
        closeText="LIMPAR"
        isRight
        component={form()}
      />
    </>
  );

  return (
    <CardContainerCommon
      title={title}
      hasFilter={hasFilter || false}
      openFilter={setOpen}
      childrens={Body()}
    />
  );
};
export default TableCommon;
